import React from 'react'
import {Container} from '../UI/Container';
export const MineralWealthSection = () => {
  return (
    <Container classes='pt-[36px]'>
        <h1 className='font-roboto-condensed font-semibold text-[64px] leading-[75px]'>
            PAKISTAN’S MINERAL 
            <span className='text-[#27AE60]'> WEALTH </span>
        </h1>
        <p className='font-roboto-condensed font-[400px] text-[20px] leading-[25px]'>Pakistan's mineral wealth is a testament to its geological diversity and rich natural resources. From valuable metals like copper and gold to precious gemstones such as emeralds and rubies, Pakistan offers a diverse array of minerals ripe for exploration and investment. This abundance of mineral resources underscores Pakistan's status as a promising destination for sustainable development and economic growth.</p>
    </Container>
  )
}

